<template>
  <sidebar-content hideSubmit :open="openModal" hasMenu @close="closeModal" title="Cadastrar um novo usuário">
    <v-container class="new-user pt-0" grid-list-lg>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-radio-group
              required
              v-model="group"
              row
              @change="changeGroup"
              :rules="validate.requiredRules"
              >
              <v-radio label="Administrador" value="administrator"></v-radio>
              <v-radio label="Supervisor" value="supervisor"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Nome"
              v-model="newUser.name"
              :rules="validate.requiredRules"
              data-cy="userEmail"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Email"
              type="email"
              v-model="newUser.email"
              :rules="validate.emailRules"
              data-cy="userEmail"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Senha"
              type="password"
              v-model="newUser.password"
              :rules="validate.requiredRules"
              data-cy="userPass"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-btn
          @click="create"
          class="btn-fixed"
          block
          :disabled="!valid"
          :loading="isLoading"
          color="accent"
          depressed
          >
          Criar usuário
        </v-btn>
      </v-form>
    </v-container>
  </sidebar-content>
</template>

<script>
  import SidebarContent from '@/components/ui/SidebarContent'

  export default {
    name: 'NewUser',
    components: {
      SidebarContent
    },
    data: () => ({
      loadingGroups: 0,
      valid: true,
      group: '',
      openModal: false,
      newUser: {
        group: '',
        name: '',
        email: '',
        password: ''
      }
    }),
    methods: {
      showModal () {
        this.openModal = true
      },
      closeModal () {
        this.openModal = false
        this.$nextTick(() => {
          let group = this.$route.params.group
          this.$router.push({ name: 'Users', params: { group } })
        })
      },
      changeGroup (group) {
        this.newUser = Object.assign({}, this.newUser, { group })
      },
      create () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('users/create', this.newUser)
          // setTimeout(() => {
          //   this._success()
          // }, 1000)
        }
      },
      _success () {
        this.$nextTick(() => {
          this.$root.$emit('snackbar', { show: true, color: 'success', text: 'Usuário criado com sucesso' })
          this.$router.push({ name: 'Users' })
        })
      },
      _failure () {
        this.$nextTick(() => {
          this.$root.$emit('snackbar', { show: true, color: 'error', text: 'houve um problema' })
        })
      }
    },
    computed: {
      isLoading () {
        return this.$store.state.isLoading
      }
    },
    mounted () {
      this.showModal()
    },
    beforeDestroy () {
      this.closeModal()
    }
  }
</script>
